<template>
  <v-app id="app_measurements">
    <v-overlay
      v-model="centerLoading"
      :scrim="false"
      class="custom_centered_overlay"
    >
      <v-progress-circular
        color="#2A8200"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">TIME MANAGEMENT</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to configure the business hours.
          </p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-8">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedDay"
              :items="days"
              label="Day*"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
              item-title="name"
              item-value="value"
              clearable
              :rules="[(v) => !!v || 'Day is required']"
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="dayInMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayInTime"
                  label="Day In"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Day In is required']"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayInTime"
                format="24hr"
                @click:minute="dayInMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="dayInBufferMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayInBufferTime"
                  label="Day In Buffer"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Day In Buffer is required']"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayInBufferTime"
                format="24hr"
                @click:minute="dayInBufferMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="morningHDMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="morningHDTime"
                  label="Morning HD Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Morning HD Leave is required']"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="morningHDTime"
                format="24hr"
                @click:minute="morningHDMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="afternoonHDMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="afternoonHDTime"
                  label="Afternoon HD Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Afternoon HD Leave is required']"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="afternoonHDTime"
                format="24hr"
                @click:minute="afternoonHDMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="fullDayLeaveMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="fullDayLeaveTime"
                  label="Full Day Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="fullDayLeaveTime"
                format="24hr"
                @click:minute="fullDayLeaveMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="dayOutMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayOutTime"
                  label="Day Out"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayOutTime"
                format="24hr"
                @click:minute="dayOutMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>

          <v-row justify="end" class="pa-4">
            <v-btn
              size="x-large"
              class="custom_btn_primary pl-5 pr-5"
              @click="verifyDialogOpen"
              >Create</v-btn
            >
            <!-- <v-btn size="x-large" class="custom_btn_primary pl-5 pr-5" @click="CreateTime()">Create</v-btn> -->
            <v-btn
              size="x-large"
              class="custom_btn_secondary ml-3"
              @click="cancel()"
              >Cancel</v-btn
            >
          </v-row>

          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col class="mt-0" cols="7">
            <p class="custom_page_main_title">LIST OF TIME DATA</p>
            <p class="custom_page_main_sub_title" style="opacity: 0.6">
              List of the all configure business hours.
            </p>
          </v-col>

          <v-dialog
            v-model="createDialog"
            max-height="700"
            max-width="700"
            persistent
            id="app_product_list"
          >
            <v-card rounded="md">
              <div class="pa-4">
                <v-card color="#F0F0F0" flat>
                  <template v-slot:prepend>
                    <v-card-title class="text-subtitle-1 font-weight-bold"
                      >CREATE TIME MANAGEMENT DATA</v-card-title
                    >
                  </template>
                  <v-spacer></v-spacer>
                  <template v-slot:append>
                    <v-btn
                      @click="createDialog = false"
                      icon="mdi-close"
                      size="x-small"
                    ></v-btn>
                  </template>
                </v-card>

                <v-card color="white" flat class="mt-3">
                  <v-card-item>
                    <v-card-title
                      style="color: #bb0000"
                      class="text-body-1 font-weight-medium"
                    >
                      <v-icon color="warning" size="small">mdi-alert</v-icon>
                      &nbsp;&nbsp;Do you want to confirm this as a new time schedule for the {{ this.selectedDay }} ?
                    </v-card-title>

                    <p
                      style="opacity: 0.7"
                      class="text-body-2 mt-4 text-justify"
                    >
                    Once published, this timeline will be applied to all future {{ this.selectedDay }}.
                      <span style="color: blue">
                        Please double-check the selected times before confirming, as this change will take effect immediately.
                      </span>
                    </p>

                    <v-divider class="mt-4"></v-divider>

                    <div class="float-end mt-4">
                      <v-btn
                      size="x-large"
                      class="custom_btn_primary pl-5 pr-5"
                        @click="CreateTime()"
                        :loading="deleteLoading"
                      >
                        CREATE
                      </v-btn>
                      <!-- <v-btn class="ml-3 custom_btn_secondary" @click="deleteDialog = false">CANCEL</v-btn> -->
                    </div>
                  </v-card-item>
                </v-card>
              </div>
            </v-card>
          </v-dialog>

          <v-data-table
            v-model:page="page"
            :loading="loading"
            :headers="headers"
            :items="timeManagementData"
            :items-per-page="itemsPerPage"
            class="custom_table_normal"
            @update:page="page = $event"
            @page-count="totalPages = $event"
          >
            <!-- Custom Styling for DAY column -->
            <template v-slot:[`item.day`]="{ item }">
              <span style="color: blue; font-weight: bold">{{ item.day }}</span>
            </template>

            <!-- Custom Styling for DAY IN column -->
            <template v-slot:[`item.day_in`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                formatTime(item.day_in)
              }}</span>
            </template>
            <template v-slot:[`item.day_in_buffer`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                formatTime(item.day_in_buffer)
              }}</span>
            </template>



            <template v-slot:[`item.created_at`]="{ item }">
              <span style="color: blue; font-weight: bold">
                {{
                  new Date(item.created_at)
                    .toISOString()
                    .slice(0, 10)
                    .replace(/-/g, "/")
                }}
              </span>
            </template>


            <!-- DELETE Button -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                style="
                  width: 70% !important;
                  background-color: #fdecea !important;
                  border: 1px solid #f44336 !important;
                  color: #f44336 !important;
                "
                variant="outlined"
                @click="confirmDelete(item)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-row>

        <v-dialog
          v-model="deleteDialog"
          max-height="500"
          max-width="500"
          persistent
          id="app_product_list"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold"
                    >DELETE TIME MANAGEMENT DATA</v-card-title
                  >
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="deleteDialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <v-card color="white" flat class="mt-3">
                <v-card-item>
                  <v-card-title
                    style="color: #bb0000"
                    class="text-body-1 font-weight-medium"
                  >
                    <v-icon color="warning" size="small">mdi-alert</v-icon>
                    &nbsp;&nbsp;Do you want to delete this time record ?
                  </v-card-title>

                  <p style="opacity: 0.7" class="text-body-2 mt-4 text-justify">
                    This will be deleted immediately. Once deleted, it can no
                    longer be used for any purpose.
                    <span style="color: blue">
                      Further, these modules are also related to the following
                      others, so please read and confirm before deleting this.
                    </span>
                  </p>

                  <!-- <v-timeline align="start" density="compact">
                    <v-timeline-item>
                      <template v-slot:opposite> </template>
                      <div>
                        <div class="text-h6">related area 01</div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </v-timeline-item>

                    <v-timeline-item>
                      <template v-slot:opposite> </template>
                      <div>
                        <div class="text-h6">related area 02</div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </v-timeline-item>
                  </v-timeline> -->

                  <v-divider class="mt-4"></v-divider>

                  <div class="float-end mt-4">
                    <v-btn
                      style="
                        width: 35% !important;
                        background-color: #fdecea !important;
                        border: 1px solid #f44336 !important;
                        color: #f44336 !important;
                      "
                      variant="outlined"
                      @click="deleteTimeManagement"
                      :loading="deleteLoading"
                    >
                      DELETE
                    </v-btn>
                    <v-btn
                      class="ml-3 custom_btn_secondary"
                      @click="deleteDialog = false"
                      >CANCEL</v-btn
                    >
                  </div>
                </v-card-item>
              </v-card>
            </div>
          </v-card>
        </v-dialog>

        <!-- Snackbar for notifications -->
        <v-snackbar
          v-model="snackbar"
          :timeout="3000"
          :color="snackbarColor"
          top
        >
          {{ snackbarMessage }}
        </v-snackbar>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      createDialog: false,
      // Days dropdown data
      days: [
        { name: "Monday", value: "Monday" },
        { name: "Tuesday", value: "Tuesday" },
        { name: "Wednesday", value: "Wednesday" },
        { name: "Thursday", value: "Thursday" },
        { name: "Friday", value: "Friday" },
        { name: "Saturday", value: "Saturday" },
        { name: "Sunday", value: "Sunday" },
      ],
      selectedDay: null,

      // Time pickers data
      dayInTime: null,
      dayInMenu: false,

      dayInBufferTime: null,
      dayInBufferMenu: false,

      morningHDTime: null,
      morningHDMenu: false,

      afternoonHDTime: null,
      afternoonHDMenu: false,

      fullDayLeaveTime: null,
      fullDayLeaveMenu: false,

      dayOutTime: null,
      dayOutMenu: false,

      // Dialog and loading states
      deleteDialog: false,
      deleteLoading: false,
      itemToDelete: null,
      userPermissions: ["delete"],
      centerLoading: false,

      // Table data
      page: 1,
      loading: false,
      itemsPerPage: 10,
      timeManagementData: [],

      // Headers for the data table
      headers: [
        { text: "DAY", value: "day", sortable: true, title: "DAY" },
        { text: "DAY IN", value: "day_in", sortable: true, title: "DAY IN" },
        {
          text: "DAY IN BUFFER",
          value: "day_in_buffer",
          sortable: true,
          title: "DAY IN BUFFER",
        },
        {
          text: "MORNING HD LEAVE",
          value: "morning_hd_leave",
          sortable: true,
          title: "MORNING HD LEAVE",
        },
        {
          text: "AFTERNOON HD LEAVE",
          value: "afternoon_hd_leave",
          sortable: true,
          title: "AFTERNOON HD LEAVE",
        },
        {
          text: "FULL DAY LEAVE",
          value: "full_day_leave",
          sortable: true,
          title: "FULL DAY LEAVE",
        },
        { text: "DAY OUT", value: "day_out", sortable: true, title: "DAY OUT" },
        // { text: "STATUS", value: "status", sortable: true,title:"DAY IN" },
        {
          text: "CREATED AT",
          value: "created_at",
          sortable: true,
          title: "CREATION DATE",
        },
        { text: "ACTION", value: "actions", sortable: false, title: "ACTION" },
      ],

      // Snackbar
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
    };
  },
  created() {
    this.fetchTimeManagementData();
  },
  methods: {
    // Format time from "HH:MM:SS" to "HH:MM AM/PM"
    formatTime(timeString) {
      if (!timeString) return "";
      const [hours, minutes] = timeString.split(":");
      const hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minutes} ${ampm}`;
    },

    // Fetch time management data from API
    async fetchTimeManagementData() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/time-management/get`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.timeManagementData = response.data.data;
        } else {
          this.showSnackbar("Failed to fetch time management data", "error");
        }
      } catch (error) {
        console.error("Error fetching time management data:", error);
        this.showSnackbar("Error fetching time management data", "error");
      } finally {
        this.loading = false;
      }
    },

    verifyDialogOpen() {
      const {
        selectedDay,
        dayInTime,
        dayInBufferTime,
        morningHDTime,
        afternoonHDTime,
        fullDayLeaveTime,
        dayOutTime,
      } = this;

      const errors = [];

      // Required field checks
      if (!selectedDay) errors.push("Selected day is required.");
      if (!dayInTime) errors.push("Day In time is required.");
      if (!dayInBufferTime) errors.push("Day In Buffer time is required.");
      if (!morningHDTime)
        errors.push("Morning half-day leave time is required.");
      if (!afternoonHDTime)
        errors.push("Afternoon half-day leave time is required.");
      if (!fullDayLeaveTime) errors.push("Full-day leave time is required.");
      if (!dayOutTime) errors.push("Day Out time is required.");

      // Logical time check: afternoon should not be before morning
      if (morningHDTime && afternoonHDTime) {
        const morning = new Date(`1970-01-01T${morningHDTime}`);
        const afternoon = new Date(`1970-01-01T${afternoonHDTime}`);
        if (afternoon < morning) {
          errors.push(
            "Afternoon half-day leave time cannot be before morning half-day leave time."
          );
        }
      }

      // If errors exist, show them and return
      if (errors.length > 0) {
        this.showSnackbar(errors.join(" "), "error");
        return;
      }

      // All validations passed
      this.createDialog = true;
    },

    // Create new time management entry
    async CreateTime() {
      if (!this.selectedDay) {
        this.showSnackbar("Please select a day", "error");
        return;
      }

      this.loading = true;
      const userId = localStorage.getItem("userId");

      const timeData = {
        userId: userId,
        day: this.selectedDay,
        day_in: this.dayInTime,
        day_in_buffer: this.dayInBufferTime,
        morning_hd_leave: this.morningHDTime,
        afternoon_hd_leave: this.afternoonHDTime,
        full_day_leave: this.fullDayLeaveTime,
        day_out: this.dayOutTime,
        status: "current",
      };

      console.log("data", timeData);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/time-management/create`,
          timeData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.showSnackbar(
            "Time management entry created successfully!",
            "success"
          );
          this.createDialog = false;
          this.resetForm();
          await this.fetchTimeManagementData();
        } else {
          this.showSnackbar("Failed to create time management entry", "error");
        }
      } catch (error) {
        console.error("Error creating time management entry:", error);
        this.handleApiError(error);
      } finally {
        this.loading = false;
      }
    },

    // Confirm delete action
    confirmDelete(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },

    // Delete time management entry
    async deleteTimeManagement() {
      if (!this.itemToDelete) return;

      this.deleteLoading = true;

      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("No auth token found");

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/time-management/delete`,
          { id: this.itemToDelete.id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.showSnackbar(
            "Time management entry deleted successfully!",
            "success"
          );
          await this.fetchTimeManagementData();
        } else {
          this.showSnackbar("Failed to delete time management entry", "error");
        }
      } catch (error) {
        console.error("Error deleting time management entry:", error);
        this.showSnackbar("Error deleting time management entry", "error");
      } finally {
        this.deleteLoading = false;
        this.deleteDialog = false;
        this.itemToDelete = null;
      }
    },

    // Reset form fields
    resetForm() {
      this.selectedDay = null;
      this.dayInTime = null;
      this.dayInBufferTime = null;
      this.morningHDTime = null;
      this.afternoonHDTime = null;
      this.fullDayLeaveTime = null;
      this.dayOutTime = null;
    },

    // Handle API errors
    handleApiError(error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors)
          .flat()
          .join(", ");
        this.showSnackbar(errorMessages, "error");
      } else {
        this.showSnackbar(
          error.message || "An unexpected error occurred",
          "error"
        );
      }
    },

    // Show snackbar notification
    showSnackbar(message, color) {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    // Other existing methods
    hasPermission(permission) {
      return this.userPermissions.includes(permission);
    },
    cancel() {
      this.resetForm();
    },
    backPageRoute() {
      // Handle back navigation
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>